<template>
  <div class="container mx-auto pb-5 max-w-[1300px]">
    <!-- fullscreen loading cover with blur effects -->
    <div v-if="isLoading" class="fixed inset-0 bg-black/30 backdrop-blur-sm z-50 flex items-center justify-center">
      <div class="bg-white p-8 rounded-lg shadow-xl flex flex-col items-center">
        <div class="w-12 h-12 rounded-full border-4 border-yellow-600/80 border-t-transparent animate-spin mb-4"></div>
        <p class="text-gray-700 font-medium">正在加载...</p>
      </div>
    </div>

    <!-- Hero banner -->
    <div class="relative" v-if="cat1_banner">
      <img class="object-cover saturate-150 w-full" :src="`${SRC_URL}${cat1_banner}`" alt="Sauter Cover" />
    </div>

    <!-- Breadcrumb navigation -->
    <p class="text-black/70 text-xs tracking-widest my-5">
      <span class="mx-5 underline underline-offset-4">
        <a href="/sauter/">Carl Johann</a> </span
      >| <span class="lg:mx-5">{{ product?.cat1_nameen }}</span
      >| <span class="lg:mx-5">{{ product?.prd_name }}</span
      >＞
    </p>

    <div class="items-center justify-center flex flex-col mx-auto">
      <!-- Brand section -->
      <div class="mt-5 mb-10 text-center">
        <div class="flex mx-auto w-60">
          <img class="object-cover" src="https://api.acton-shanghai.cn/imgs/Brand/20180423134145035.jpg" />
        </div>
      </div>

      <!-- Product details section -->
      <div class="w-full max-w-[600px] mx-auto px-2 sm:px-4" id="model" v-if="!isLoading && productData">
        <div class="flex flex-col mx-auto items-center w-full">
          <img
            v-if="product?.prd_cover"
            class="w-full h-auto max-w-full cursor-pointer object-cover saturate-100 lg:min-h-[400px] lg:max-h-[400px]"
            :src="currentMainImage || `${SRC_URL}${product.prd_cover}`"
            @click="openGallery(currentMainImage || `${SRC_URL}${product.prd_cover}`)"
            :alt="product?.prd_name"
          />
          <!-- 当前图的文字描述 -->
          <p v-if="currentImageDescription || product?.prd_name" class="text-center text-gray-600/60 mt-3 w-full px-2 sm:px-4 text-sm sm:text-base">
            {{ currentImageDescription || product?.prd_name }}
          </p>
        </div>
        <!-- 图库小图横向排列，一行最多5个，支持横向拖动 -->
        <div v-if="album.length > 0 || product?.prd_cover" class="mt-4 w-full">
          <div class="overflow-x-auto scrollbar-hide w-full" style="scrollbar-width: thin; scrollbar-color: #d1d5db transparent">
            <div class="flex gap-2 justify-start lg:justify-center px-2" style="min-width: max-content">
              <!-- 主图缩略图 -->
              <div v-if="product?.prd_cover" class="relative cursor-pointer group flex-shrink-0">
                <div
                  class="relative overflow-hidden w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 rounded border-2 transition-all"
                  :class="
                    currentMainImage === `${SRC_URL}${product.prd_cover}` || (!currentMainImage && (album.length > 0 || product.prd_cover))
                      ? 'border-yellow-600'
                      : 'border-gray-300 hover:border-yellow-400'
                  "
                >
                  <img
                    class="w-full h-full object-cover"
                    :src="`${SRC_URL}${product.prd_cover}`"
                    @click="changeMainImage(`${SRC_URL}${product.prd_cover}`)"
                    @dblclick="openGallery(`${SRC_URL}${product.prd_cover}`)"
                    :alt="product?.prd_name"
                  />
                </div>
              </div>
              <!-- 图库缩略图 -->
              <div v-for="item in album" :key="item.id" class="relative cursor-pointer group flex-shrink-0">
                <div
                  class="relative overflow-hidden w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 rounded border-2 transition-all"
                  :class="currentMainImage === `${SRC_URL}${item.pro_albu}` ? 'border-yellow-600' : 'border-gray-300 hover:border-yellow-400'"
                >
                  <img
                    class="w-full h-full object-cover"
                    :src="`${SRC_URL}${item.pro_albu}`"
                    @click="changeMainImage(`${SRC_URL}${item.pro_albu}`)"
                    @dblclick="openGallery(`${SRC_URL}${item.pro_albu}`)"
                    :alt="product?.prd_name"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-justify my-6 sm:my-10 px-2 sm:px-0" id="modelName">
          <p class="text-3xl lg:text-4xl text-center font-serif font-bold uppercase break-words">{{ product?.prd_name }}</p>
          <p class="text-sm text-center py-4 italic underline underline-offset-4">
           建议零售价： {{ product?.prd_listprice ? parseFloat(product.prd_listprice).toFixed(2) : '' }} 元
          </p>
        </div>

        <!-- Tab切换按钮 -->
        <div class="flex border-b justify-center border-gray-300 mb-5 lg:min-w-[600px]">
          <div class="flex justify-center">
            <button
              :class="{
                'min-w-[12rem] py-2 px-20 border-b-4 border-gray-900 hover:text-gray-600 text-gray-800 font-bold transition duration-200':
                  selectedTab === 'tab1',
                'py-2 px-10 border-b-4 border-gray-600/30 hover:text-gray-500 text-gray-600 font-bold': selectedTab !== 'tab1',
              }"
              @click="selectedTab = 'tab1'"
            >
              钢琴
            </button>
            <button
              :class="{
                'min-w-[12rem] py-2 px-20 border-b-4 border-red-600 hover:text-gray-600 text-gray-800 font-bold transition duration-200':
                  selectedTab === 'tab2',
                'py-2 px-10 border-b-4 border-red-600/50 hover:text-gray-500 text-gray-600 font-bold': selectedTab !== 'tab2',
              }"
              @click="selectedTab = 'tab2'"
            >
              规格
            </button>
          </div>
        </div>

        <!-- Tab内容区域 -->
        <div :class="['content flex mx-auto justify-center', selectedTab === 'tab2' ? 'w-full max-w-full' : 'lg:min-w-[600px] max-w-[600px]']">
          <div :class="selectedTab === 'tab2' ? 'w-full' : ''">
            <!-- Logo显示 -->
            <div v-if="selectedTab === 'tab1'" class="flex mx-auto w-60">
              <img class="object-cover" src="https://api.acton-shanghai.cn/imgs/Brand/20180423134145035.jpg" />
            </div>

            <!-- 钢琴Tab内容 -->
            <div v-if="selectedTab === 'tab1'" class="p-4 lg:min-w-[600px]">
              <div
                class="contents text-black/80 leading-6 sm:leading-8 space-y-4 text-justify text-sm sm:text-base"
                v-html="`${cleanHtml(product?.prd_features)}`"
              ></div>
            </div>

            <!-- 规格Tab内容 -->
             
            <div
              v-if="selectedTab === 'tab2'"
              class="relative p-2 sm:p-4 w-full mx-auto flex flex-col justify-center min-h-[600px]"
            >
              <img src="/images/spec-cover.jpg" class="object-cover w-full h-full absolute inset-0" />
              <div class="absolute z-10 top-4 sm:top-6 lg:top-10 left-0 right-0 px-2 sm:px-4">
                <div class="flex mx-auto w-60">
          <img class="object-cover" src="https://api.acton-shanghai.cn/imgs/Brand/20180423134145035.jpg" />
        </div>
                <div class="flex flex-col items-center">
                  <img class="w-40 sm:w-32 lg:w-40 mb-2" v-lazy="`${SRC_URL}${brand?.b_logo}`" />
                  <p class="pt-2 sm:pt-3 text-sm sm:text-base lg:text-lg font-serif font-bold uppercase text-center break-words">
                    {{ product?.prd_name }}
                  </p>
                  <p class="text-black/60 text-xs font-mono text-center">{{ product?.cat1_namecn }}</p>
                  <p
                    class="text-black/80 leading-relaxed sm:leading-loose tracking-wider py-2 italic text-xs sm:text-sm text-center"
                    v-html="`${cleanHtml(product?.prd_spec)}`"
                  ></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty state -->
      <div v-else-if="!isLoading && !productData" class="text-center py-10">
        <p>暂无产品数据</p>
      </div>
    </div>

    <!-- Back to list button -->
    <div class="text-center py-5">
      <a
        href="/pianos/carl/legend/54"
        class="my-10 rounded-full tracking-widest duration-300 text-white lg:border-[1px] bg-black lg:border-gray-500 text-sm hover:bg-white hover:text-black px-6 py-2"
      >
        返回列表
      </a>
    </div>

    <!-- 全屏图片画廊 -->
    <div v-if="showGallery" class="fixed inset-0 bg-black/95 backdrop-blur-sm z-[100] flex items-center justify-center" @click.self="closeGallery">
      <div class="relative w-full h-full flex items-center justify-center px-4 sm:px-8">
        <!-- 关闭按钮 -->
        <button
          @click="closeGallery"
          class="absolute top-4 right-4 sm:top-6 sm:right-6 z-10 text-white hover:text-yellow-400 transition-colors duration-200 bg-black/50 rounded-full p-2 hover:bg-black/70"
        >
          <svg class="w-6 h-6 sm:w-8 sm:h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <!-- 左箭头 -->
        <button
          v-if="allImages.length > 1"
          @click.stop="prevImage"
          class="absolute left-4 sm:left-8 z-10 text-white hover:text-yellow-400 transition-colors duration-200 bg-black/50 rounded-full p-2 sm:p-3 hover:bg-black/70"
          :disabled="currentGalleryIndex === 0"
        >
          <svg class="w-6 h-6 sm:w-8 sm:h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <!-- 图片容器 -->
        <div class="relative max-w-full max-h-full flex items-center justify-center">
          <img
            :src="allImages[currentGalleryIndex]"
            :alt="`图片 ${currentGalleryIndex + 1} / ${allImages.length}`"
            class="max-w-full max-h-[90vh] object-contain"
            @click.stop
          />
        </div>

        <!-- 右箭头 -->
        <button
          v-if="allImages.length > 1"
          @click.stop="nextImage"
          class="absolute right-4 sm:right-8 z-10 text-white hover:text-yellow-400 transition-colors duration-200 bg-black/50 rounded-full p-2 sm:p-3 hover:bg-black/70"
          :disabled="currentGalleryIndex === allImages.length - 1"
        >
          <svg class="w-6 h-6 sm:w-8 sm:h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>

        <!-- 图片索引指示器 -->
        <div
          v-if="allImages.length > 1"
          class="absolute bottom-4 sm:bottom-6 left-1/2 transform -translate-x-1/2 z-10 bg-black/50 text-white px-4 py-2 rounded-full text-sm sm:text-base"
        >
          {{ currentGalleryIndex + 1 }} / {{ allImages.length }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const API_URL = "https://api.acton-shanghai.cn/openRDS/";
const SRC_URL = "https://api.acton-shanghai.cn";
const pageTitle = ref("雅登乐器 | SAUTER 首德钢琴");

const BRAND_ID = 16; // Brand ID constant
const productData = ref(null);
const brandData = ref(null);
const album = ref([]);
const cat1_banner = ref("");
const isLoading = ref(true);
const selectedTab = ref("tab1"); // Tab切换状态

// 当前显示的主图
const currentMainImage = ref("");
// 当前图的文字描述
const currentImageDescription = ref("");

// 画廊相关状态
const showGallery = ref(false);
const currentGalleryIndex = ref(0);

// 所有图片的数组（主图 + 图库图片）
const allImages = computed(() => {
  const images = [];
  if (product.value?.prd_cover) {
    images.push(`${SRC_URL}${product.value.prd_cover}`);
  }
  if (album.value && album.value.length > 0) {
    album.value.forEach((item) => {
      if (item.pro_albu) {
        images.push(`${SRC_URL}${item.pro_albu}`);
      }
    });
  }
  return images;
});

// Computed properties for cleaner template access
const product = computed(() => productData.value?.[0] || {});
const brand = computed(() => brandData.value?.[0] || {});

// 切换主图
const changeMainImage = (imageSrc) => {
  if (!imageSrc) return;
  currentMainImage.value = imageSrc;
  // 根据当前图片获取对应的 styleName
  if (product.value?.prd_cover && imageSrc === `${SRC_URL}${product.value.prd_cover}`) {
    // 主图，从 product 中获取 styleName
    currentImageDescription.value = product.value?.styleName || product.value?.prd_name || "";
  } else {
    // 图库图片，从 album 中查找对应的 styleName
    const albumItem = album.value.find((item) => item.pro_albu && `${SRC_URL}${item.pro_albu}` === imageSrc);
    currentImageDescription.value = albumItem?.styleName || "";
  }
};

// 打开画廊
const openGallery = (imageSrc) => {
  if (!imageSrc) return;
  const index = allImages.value.findIndex((img) => img === imageSrc);
  if (index !== -1) {
    currentGalleryIndex.value = index;
    showGallery.value = true;
    document.body.style.overflow = "hidden";
  } else if (allImages.value.length > 0) {
    // 如果找不到精确匹配，使用第一张图片
    currentGalleryIndex.value = 0;
    showGallery.value = true;
    document.body.style.overflow = "hidden";
  }
};

// 关闭画廊
const closeGallery = () => {
  showGallery.value = false;
  document.body.style.overflow = "";
};

// 上一张图片
const prevImage = () => {
  if (currentGalleryIndex.value > 0) {
    currentGalleryIndex.value--;
  } else {
    currentGalleryIndex.value = allImages.value.length - 1; // 循环到最后一张
  }
};

// 下一张图片
const nextImage = () => {
  if (currentGalleryIndex.value < allImages.value.length - 1) {
    currentGalleryIndex.value++;
  } else {
    currentGalleryIndex.value = 0; // 循环到第一张
  }
};

// 键盘事件处理
const handleKeydown = (event) => {
  if (!showGallery.value) return;

  switch (event.key) {
    case "Escape":
      closeGallery();
      break;
    case "ArrowLeft":
      event.preventDefault();
      prevImage();
      break;
    case "ArrowRight":
      event.preventDefault();
      nextImage();
      break;
  }
};

// Clean HTML content by removing styles and fixing image paths
const cleanHtml = (html) => {
  if (!html) return "";

  const doc = new DOMParser().parseFromString(html, "text/html");

  // Remove all style attributes
  doc.querySelectorAll("[style]").forEach((element) => element.removeAttribute("style"));

  // Remove empty paragraph tags
  doc.querySelectorAll("p").forEach((p) => {
    if (p.innerHTML === "<br>") {
      p.remove();
    }
  });

  // Fix image URLs
  doc.querySelectorAll("img").forEach((img) => {
    const src = img.getAttribute("src");
    if (src && !src.includes("http")) {
      img.setAttribute("src", SRC_URL + src);
    }
  });

  return doc.body.innerHTML;
};

// Fetch data from API
const fetchData = async () => {
  isLoading.value = true;
  try {
    const fetchResource = async (endpoint) => {
      const response = await fetch(`${API_URL}${endpoint}`);
      if (!response.ok) throw new Error(`Failed to fetch: ${endpoint}`);
      return response.json();
    };

    // Fetch product details using the ID from route params
    const productId = route.params.id;
    productData.value = await fetchResource(`api/product/id/${productId}`);
    album.value = await fetchResource(`api/album/id/${productId}`);

    // Fetch brand information
    brandData.value = await fetchResource(`api/brand/id/${BRAND_ID}`);

    // Fetch cat1_banner using cat1_id from product
    if (productData.value?.[0]?.cat1_id) {
      const cat1_id = productData.value[0].cat1_id;
      const cat1Data = await fetchResource(`api/cat1/list/15/id/${cat1_id}`);
      if (cat1Data?.[0]?.cat1_banner) {
        cat1_banner.value = cat1Data[0].cat1_banner;
      }
    }

    // 初始化时设置主图的描述
    if (productData.value?.[0]?.styleName) {
      currentImageDescription.value = productData.value[0].styleName;
    }

    // 添加人为延迟，使loading效果更明显
    await new Promise((resolve) => setTimeout(resolve, 1000));
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  document.title = pageTitle.value;
  fetchData();
  // 添加键盘事件监听
  window.addEventListener("keydown", handleKeydown);
});

// 组件卸载时移除事件监听
import { onUnmounted } from "vue";
onUnmounted(() => {
  window.removeEventListener("keydown", handleKeydown);
  document.body.style.overflow = "";
});
</script>

<style scoped>
/* 隐藏滚动条但保持滚动功能 */
.scrollbar-hide {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: thin; /* Firefox */
}

.scrollbar-hide::-webkit-scrollbar {
  display: none; /* Chrome, Safari and Opera */
}

/* 平滑滚动 */
.scrollbar-hide {
  scroll-behavior: smooth;
}

/* 画廊动画 */
.fade-in {
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Logo样式 */
.colored-logo {
  filter: invert(100%);
  /* 将SVG图片反相 */
}

/* Tab内容样式 */
.content img {
  display: block;
  margin: 0 auto;
  width: 100%;
}

.content p {
  line-height: 28px;
  text-align: justify;
  margin-bottom: 10px;
  color: #353333;
}

.content strong {
  line-height: 35px;
}
</style>
